import {computed} from 'vue'
import {useAuthStore} from '@toolify/client/src/stores/AuthStore/useAuthStore'
import {TimeFormatType} from '@toolify/server/src/services/UserSettingsService/strategies/TimeFormatUserSettingStrategy/enum/TimeFormatType'
import {format} from 'date-fns'
import {EntityType} from '@toolify/server/src/services/EntityService/enum/EntityType'
import {IUserResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IUserResponseInstance'

export function useTimeFormat() {
  const authStore = useAuthStore()

  const currentTimeFormat = computed<TimeFormatType>(() => {
    const user = authStore.currentEntity?.entityType === EntityType.User
      ? authStore.currentEntity.payload as IUserResponseInstance
      : null
    return user?.settings?.timeFormat || TimeFormatType.Format24h
  })

  const isTwelveHourFormat = computed(() => {
    return currentTimeFormat.value === TimeFormatType.Format12h
  })

  const clockTimeFormat = computed(() => {
    return isTwelveHourFormat.value ? 'h:mm a' : 'HH:mm'
  })

  const formatClockTime = (date: Date): string => {
    if (!date) {
      return ''
    }
    return format(date, clockTimeFormat.value)
  }

  return {
    currentTimeFormat,
    isTwelveHourFormat,
    clockTimeFormat,
    formatClockTime,
  }
}
